import ImageGridSection2 from './ImageGridSection2';

export default ImageGridSection2;